import React from 'react'
import { useSelector } from 'react-redux'

import { isNewStylesThemeEnabledSelector } from '../../modules/selectors/app'

import useStyles from './styles'
import * as classes from './styles.css'

function Toggle({ isEnabled, onToggle, isBig, isSolid = true }: ToggleProps) {
  const isNewStylesThemeEnabled = useSelector(isNewStylesThemeEnabledSelector)
  // @ts-ignore
  const legacyClasses = useStyles({ isEnabled, isBig, isSolid })
  const vanillaClasses = {
    toggleContainer: classes.toggleContainer({
      border: isSolid ? 'default' : 'hasBorder',
      state: isEnabled ? (isSolid ? 'enabledSolid' : 'enabledOutline') : undefined,
      size: isBig ? 'big' : 'small'
    }),
    toggleBtn: classes.toggleBtn({ size: isBig ? 'big' : 'small' })
  }
  const activeClasses = isNewStylesThemeEnabled ? vanillaClasses : legacyClasses

  return (
    <div className={activeClasses.toggleContainer} onClick={onToggle}>
      <span className={activeClasses.toggleBtn} />
    </div>
  )
}

interface ToggleProps {
  isEnabled?: boolean
  onToggle?: () => void
  isBig?: boolean
  isSolid?: boolean
}

export default Toggle
